"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageSuccessModal = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var ModalFooter_1 = require("reactstrap/lib/ModalFooter");
var services_1 = require("@falcon/services");
var StorageSuccessModal = /** @class */ (function (_super) {
    __extends(StorageSuccessModal, _super);
    function StorageSuccessModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: true
        };
        _this.close = _this.close.bind(_this);
        return _this;
    }
    StorageSuccessModal.prototype.render = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.close });
        return (React.createElement(reactstrap_1.Modal, { className: "success-modal ".concat(this.props.cssClass ? this.props.cssClass : ""), isOpen: this.state.isOpen },
            React.createElement(reactstrap_1.ModalHeader, { close: closeBtn },
                React.createElement("div", { className: "d-flex success-icon-container" },
                    React.createElement("img", { className: "d-block mb-3 success-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/check-mark-big.svg"), alt: "Payment complete picture", "aria-label": "Payment complete picture", tabIndex: 0 }))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0" },
                React.createElement("span", { className: "success-title" }, this.props.title),
                React.createElement("div", null, this.props.explanationWording)),
            React.createElement("div", { className: "empty-column" }),
            React.createElement(ModalFooter_1.default, null,
                React.createElement("button", { type: "button", className: "btn btn-primary btn-blue-dashboard btn-modal", onClick: this.close }, "Ok, I understand"))));
    };
    StorageSuccessModal.prototype.close = function () {
        window.sessionStorage.removeItem("showPopup");
        var referrerJourney = window.sessionStorage.getItem("referrerJourney");
        var mtaSuccessPopupMessage = window.sessionStorage.getItem("mtaSuccessMessageText");
        if (referrerJourney && referrerJourney === services_1.INTERACTION_PROCESS_MTA && mtaSuccessPopupMessage) {
            window.sessionStorage.removeItem("mtaSuccessMessageText");
        }
        this.setState({
            isOpen: false
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    };
    return StorageSuccessModal;
}(React.Component));
exports.StorageSuccessModal = StorageSuccessModal;
//# sourceMappingURL=StorageSuccessModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/modals/StorageSuccessModal.js
// module id = 1238
// module chunks = 0